import React, { useCallback, useContext, useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import "./App.scss";
import AppRoutes from "./AppRoutes";
import Navbar from "./shared/Navbar";
import Sidebar from "./shared/Sidebar";
import Footer from "./shared/Footer";
import { withTranslation } from "react-i18next";
import ModalPopUp from "./helper/modalEvent";
import { useEventOcurred } from "./hooks/useEventOcurred";
import Context from "./helper/context";
import { pageInfo } from "./shared/layout/navigation";

const App = (props) => {
  const context = useContext(Context);
  const { authState } = context;
  const [modalEvent, setModalEvent] = useState({ data: null, show: false });
  const [eventOcurred, refreshEventOcurred, confirmEventOcurred] = useEventOcurred();

  const [compact, setCompact] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const closeMobile = useCallback(() => setMobileOpen(false), []);
  const isFullPageLayout = /^\/(login|error-pages)(\/|$)/.test(props.location.pathname);
  const page = pageInfo(props.location.pathname);
  const isMapLayout = ["/gps-map", "/devices-map", "/gesture-map"].includes(props.location.pathname);
  useEffect(() => {
    if (authState) {
      refreshEventOcurred();
      const eventTimer = setInterval(() => {
        refreshEventOcurred();
      }, 30000);

      return () => {
        if (eventTimer) clearInterval(eventTimer);
      };
    }
  }, [authState]);

  useEffect(() => {
    window.scrollTo(0, 0);
    setMobileOpen(false);
  }, [props.location]);

  useEffect(() => {
    if (eventOcurred && !modalEvent.show) {
      setModalEvent({ data: eventOcurred, show: true });
    }
  }, [eventOcurred]);

  const handleCloseModalEvent = (data) => {
    confirmEventOcurred(data);
    setModalEvent({ data: null, show: false });
  };

  const handleConfirmModalEvent = (data) => {
    confirmEventOcurred(data);
    setModalEvent({ data: null, show: false });
  };

  return (
    <div className={`container-scroller workspace-shell ${compact ? "is-compact" : ""} ${isMapLayout ? "is-map-layout" : ""} ${props.location.pathname.startsWith("/forms/") ? "is-crud-layout" : ""} ${isFullPageLayout ? "is-auth-layout" : ""}`}>
      {!isFullPageLayout && <a className="workspace-skip-link" href="#workspace-main">Ir para o conteúdo</a>}
      <ModalPopUp data={modalEvent.data} showModal={modalEvent.show} handleClose={handleCloseModalEvent} handleConfirm={handleConfirmModalEvent} />
      {!isFullPageLayout && <Sidebar compact={compact} mobileOpen={mobileOpen} onClose={closeMobile} onExpand={() => setCompact(false)} />}
      <div className={`container-fluid page-body-wrapper ${isFullPageLayout ? "full-page-wrapper" : ""}`}>
        {!isFullPageLayout && <Navbar compact={compact} mobileOpen={mobileOpen} onToggleCompact={() => setCompact(value => !value)} onToggleMobile={() => { setCompact(false); setMobileOpen(value => !value); }} />}
        <div className="main-panel">
          <main id="workspace-main" className="content-wrapper" tabIndex="-1">
            {!isFullPageLayout && props.location.pathname.startsWith("/forms/") && <div className="workspace-page-intro"><span className="workspace-eyebrow">Workspace · {page.section}</span><h1>{page.label}</h1></div>}
            <AppRoutes />
          </main>
          {!isFullPageLayout && <Footer />}
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(withRouter(App));
